import React from "react";
import "./blueButton.css";
import { Link } from "react-router-dom";
import Arrow from "./Arrow.png";
const Bluebutton = (props) => {
  return (
    <>
      <Link
        to={`/${props.Link}`}
        className="removeLinkDecoration"
      >
        <button className="bluebutton">{props.Text} <img src={Arrow} alt="Arrow" /></button>
        
      </Link>
    </>
  );
};

export default Bluebutton;
